import { colorOrange, fontWeightStrong } from '@atlas-frontend/design-tokens';
import styled from 'styled-components';

export const OrangeString = styled.span`
  font-weight: ${fontWeightStrong};
  color: ${colorOrange[6]};
`;
